<template>
	<div class="scan">
    <pt-sub-title title="批量上传报告"></pt-sub-title>
      <!-- <h1 class="statistics">待处理订单：<span class="num" v-if="unreceived">{{unreceived}}</span> <i class="el-icon-loading" v-else></i></h1> -->
      <!-- 表单 -->
      <upload-report-form :isUpload="isUpload" v-model="form" ref="child" @getResult="getResult" @updateLoading="updateLoading" :isLoading="isLoading"></upload-report-form>
</div>
</template>
<script>
import uploadReportForm from '../components-with-data/upload-report-form.vue'
export default {
  name: 'process-dialog',
  props: {
    quantity: {
      type: String
    }
  },
  components: {
    uploadReportForm
  },
  data () {
    return {
      loading: false,
      searchParams: { batchNumber: this.batchNum },
      serachValue: [],
      submitList: [],
      unHandle: 0,
      notificeRefresh: false,
      mouseDown: false,
      isCanScan: false,
      scanValue: '',
      unreceived: this.quantity,
      form: {},
      // 扫码的客户样本编号集合，防止重复
      scanSet: new Set(),
      isUpload: true,
      isLoading: false
    }
  },
  watch: {
    quantity (val, old) {
      this.unreceived = val
    }
  },
  methods: {
    getResult (response) {
      this.unreceived = response.data.unreceived
      this.$emit('updateLoading', false)
      this.$emit('refresh')
      this.$emit('update:dialogVisible', false)
    },
    updateLoading (val) {
      this.$emit('updateLoading', val)
      if (!val) {
        this.isLoading = true
      }
    },
    uploadSubmit () {
      console.log('uploadSubmit')
      this.$refs.child.formValidate().then(() => {
        // 将扫描的执行接口
        this.$emit('updateLoading', true)
        this.$refs.child.submitForm()
      })
    }
  },
  created () {
    // 监听浏览器tab切换事件
    document.addEventListener('visibilitychange', this.activeTab)
  },
  beforeDestory () { // 解绑事件监听
    document.removeEventListener('visibilitychange', this.activeTab)
  }
}
</script>
<style lang="less">
.scan{
	.scan-tip{
		font-size:18px;
		padding:20px 0;
	}
}
</style>
